import styled from "styled-components"

const ItemIcon = styled.img`
  min-width: 30px;
  width: 30px;
  height: 30px;
`

export default ItemIcon
